import { UPDATE_REMITTANCE_PAYOUT_CYCLE_FAILURE, UPDATE_REMITTANCE_PAYOUT_CYCLE_REQUEST, UPDATE_REMITTANCE_PAYOUT_CYCLE_RESET, UPDATE_REMITTANCE_PAYOUT_CYCLE_SUCCESS, } from "../../actions";
const initialState = {
    ActivePlanData: null,
    loading: false,
    error: null,
};
const updateRemittnacePayoutCycleReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_REMITTANCE_PAYOUT_CYCLE_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, ActivePlanData: action.payload });
        case UPDATE_REMITTANCE_PAYOUT_CYCLE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, ActivePlanData: null, error: null });
        case UPDATE_REMITTANCE_PAYOUT_CYCLE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, ActivePlanData: null });
        case UPDATE_REMITTANCE_PAYOUT_CYCLE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, ActivePlanData: null, error: null });
        default:
            return state;
    }
};
export default updateRemittnacePayoutCycleReducer;
